module.exports = {
  "country": "DK",
  "artist": "Saba",
  "song": "Sand",
  "year": "2024",
  "place": "NQ",
  "spotify": "79feeOJI7Rk8xwDdrOFsDO"
};